import { Outlet } from "@remix-run/react";

import { CartSidebar } from "~/modules/Cart/CartSidebar";

import { AmbientBackground } from "./components/AmbientBackground";
import { FloatingActions } from "./components/FloatingActions";
import { LandingHeader } from "./components/LandingHeader";
import { LandingNewFooter } from "./components/LandingNewFooter";

export default function LandingLayout() {
  return (
    <div
      className="font-landing relative flex min-h-screen flex-col bg-transparent"
      style={{ overflowX: "clip" }}
    >
      <AmbientBackground />
      <LandingHeader />
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
      <LandingNewFooter />
      <CartSidebar />
      <FloatingActions />
    </div>
  );
}
